import styled from "styled-components/macro";

export const CircleButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  padding: 12px;
  border-radius: 50%;
  background-color: var(--document-background);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 15px;
  border: none;
  outline: none;
  cursor: pointer;

  &:hover {
    background-color: var(--document-background-hover);
  }

  &:active {
    background-color: var(--document-background-active);
  }

  &:focus-visible {
    outline: 2px solid var(--primary-cta-high-contrast);
    outline-offset: 2px;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;

    path {
      fill: var(--grey-0);
    }
  }
`;
